import React from "react";
import { format } from "date-fns";
import CalendarIcon from "../../icons/calendarIcon";
import { useAuth } from "../../hooks/useAuth";
import styles from "./style.module.css";

const SnapshotCard = ({ snapshot, customClass = "" }) => {
  const { auth } = useAuth();
  let monitorBy =
    auth?.monitorBy?.charAt(0).toUpperCase() + auth?.monitorBy?.slice(1);
  if (monitorBy === "Days") {
    monitorBy = "Track Days";
  } else if (monitorBy === "Sessions") {
    monitorBy = "Sessions";
  } else if (monitorBy === "Laps") {
    monitorBy = "Miles";
  }
  const date = snapshot.lastServiceDate
    ? format(
        new Date(snapshot.lastServiceDate.replace("Z", "")),
        "MMMM dd, yyyy"
      )
    : "";
  let snapshotStatus = snapshot.status;
  let snapshotStatusStyle = snapshot.statusStyle;
  if (snapshotStatus <= 0) {
    snapshotStatus = "Overdue";
  } else {
    snapshotStatus = snapshotStatus + " " + monitorBy + " Left";
  }
  return (
    <div className={`${styles.snapshot_card} ${customClass}`}>
      <div className={styles.snapshot_card_head}>
        <div className={styles.snapshot_card_head_title}>
          {snapshot.consumable.name}
        </div>
        {snapshot.months > 0 && (
          <div className={styles.snapshot_card_head_ms}>
            Months Since: {Math.round(snapshot.months)}
          </div>
        )}
      </div>
      <div className={styles.snapshot_card_body}>
        <div className={styles.snapshot_card_body_items}>
          {date && (
            <div className={styles.snapshot_card_body_item_date}>
              <CalendarIcon />
              <span>{date}</span>
            </div>
          )}
          {date && <div className={styles.snapshot_card_body_divider} />}
          <div className={styles.snapshot_card_body_item}>
            Expected Life: {snapshot.trackDays} {monitorBy}
          </div>
        </div>
        {date ? (
          <div
            className={`${styles.snapshot_card_body_status} ${styles[snapshotStatusStyle]}`}
          >
            {snapshotStatus}
          </div>
        ) : (
          <div
            className={`${styles.snapshot_card_body_status} ${styles["overdue"]}`}
          >
            No Service Entered
          </div>
        )}
      </div>
    </div>
  );
};

export default SnapshotCard;
